module.exports = __webpack_public_path__ + "static/media/NMDC_F1.d9fcaec6.txt";